import { TruckOperationStatus } from "@shared-features/enums/truck-operation-status.enum";

export class BulkTruck {
  fleetId: number;
  plateNumber: string;
  pictureId: number;
  brand: string;
  brandId: number;
  truckType: string;
  truckTypeId: number;
  manufactureYear: number;
  sequenceNumber: number;
  ownerName: string;
  weight: number;
  volume: number;
  licenseExpiry: Date|string;
  driverMobileNumber: string;
  coDriverMobileNumber: string;
  ownershipType: string; // enum
  dailyPrice: number;
  operationStatus: TruckOperationStatus;
}


export class ValidatedBulkTruck extends BulkTruck {
  errors?: {property: string, messages: string[]}[];

  get exist(): boolean {
    /**
     * @todo: what makes the driver is exist?
     */
    return !!this.errors && !!this.errors.find(err => err.messages.join(', ').includes('already exists'));
  }

  get duplicated(): boolean {
    return !!this.errors && !!this.errors.find(err => err.messages.join(', ').includes('duplicated'));
  }

  get failed(): boolean {
    return !!this.errors && !!this.errors.length;
  }
}
